// generated — do not edit. Built from client/src/tours/*.md by client/scripts/build-tours.js.
// To change words or cards, edit the .md files and run: npm run tours:build
/* eslint-disable */
import type { CoachTour, CoachNudge } from '../lib/coachTypes';

export const COACH_ANCHOR_IDS = [
  "app.env",
  "app.members",
  "app.settings",
  "app.tasks",
  "app.title-row",
  "apps.grid",
  "apps.new",
  "apps.tabs",
  "home.account",
  "home.bulb",
  "home.composer",
  "home.composer-mode",
  "home.composer-plus",
  "home.credit",
  "home.recent",
  "home.sidebar-apps",
  "home.sidebar-mode",
  "home.sidebar-templates",
  "home.tab-fullstack",
  "home.tab-landing",
  "home.tab-mobile",
  "settings.billing",
  "settings.github",
  "settings.preferences",
  "settings.tabs",
  "team.invite",
  "team.members",
  "tpl.grid",
  "tpl.kinds",
  "tpl.result",
  "tpl.search",
  "tpl.use",
  "ws.back-to-apps",
  "ws.bulb",
  "ws.composer",
  "ws.credit",
  "ws.history",
  "ws.invite",
  "ws.picker",
  "ws.preview",
  "ws.publish",
  "ws.save",
  "ws.task-rail",
  "ws.viewport",
  "ws.views"
] as const;

type GeneratedTourIdLiteral = "app-details" | "apps-all" | "home" | "settings" | "team" | "templates" | "workspace";

const tours: Record<GeneratedTourIdLiteral, CoachTour> = {
  "app-details": {
    "id": "app-details",
    "version": 1,
    "routes": [
      "/apps/:id"
    ],
    "title": "This app",
    "auto": "new-user",
    "entry": "home.bulb",
    "steps": [
      {
        "anchor": "app.title-row",
        "side": "bottom",
        "title": "Name and more",
        "body": "This is your app's name. The three dots let you rename, pin or delete it.",
        "since": 1
      },
      {
        "anchor": "app.members",
        "side": "bottom",
        "title": "Who can open it",
        "body": "People with access show here. Invite more from inside the app.",
        "since": 1,
        "optional": true
      },
      {
        "anchor": "app.settings",
        "side": "bottom",
        "title": "Web address and setup",
        "body": "Your app's web address lives here. Most people never need to change it.",
        "since": 1
      },
      {
        "anchor": "app.env",
        "side": "bottom",
        "title": "Secret keys",
        "body": "Some apps need keys to talk to other tools. Keep them here. They stay private.",
        "since": 1
      },
      {
        "anchor": "app.tasks",
        "side": "bottom",
        "title": "Every task on this app",
        "body": "Each thing you asked for is a task. {Click} one to open it and keep going.",
        "since": 1,
        "highlight": "none"
      },
      {
        "anchor": "home.bulb",
        "side": "right",
        "title": "Find this again",
        "body": "Want this tour again? {Click} this bulb. It glows when a page has something new to show.",
        "since": 1
      }
    ]
  },
  "apps-all": {
    "id": "apps-all",
    "version": 1,
    "routes": [
      "/apps/all"
    ],
    "title": "All your apps",
    "auto": "new-user",
    "entry": "home.bulb",
    "steps": [
      {
        "anchor": "apps.new",
        "side": "bottom",
        "title": "Start a new app",
        "body": "{Click} **New App** to make a new app. It takes you to the home page.",
        "since": 1
      },
      {
        "anchor": "apps.tabs",
        "side": "bottom",
        "title": "All of them, or just some",
        "body": "**All Apps** shows everything. **My Apps** are the ones you made. **Shared with me** are the ones others invited you to.",
        "since": 1,
        "advance": {
          "kind": "click"
        },
        "hint": "Try it: {click} a tab"
      },
      {
        "anchor": "apps.grid",
        "side": "top",
        "title": "Open an app",
        "body": "{Click} a card to open the app. The three dots let you pin, rename or delete it.",
        "since": 1,
        "highlight": "none",
        "optional": true
      },
      {
        "anchor": "home.bulb",
        "side": "right",
        "title": "Find this again",
        "body": "Want this tour again? {Click} this bulb. It glows when a page has something new to show.",
        "since": 1
      }
    ]
  },
  "home": {
    "id": "home",
    "version": 4,
    "routes": [
      "/apps"
    ],
    "title": "Your home base",
    "auto": "new-user",
    "entry": "home.bulb",
    "steps": [
      {
        "anchor": "home.tab-landing",
        "side": "top",
        "title": "Make a page for your business",
        "body": "**Landing Page** builds marketing pages that tell people what you do and get them to sign up, book or buy. Live in minutes.",
        "since": 1
      },
      {
        "anchor": "home.tab-fullstack",
        "side": "top",
        "title": "Make a full stack app",
        "body": "**Full Stack** builds a real app with sign-ins, saved data and an admin area. Run your business on it, not on paid software.",
        "since": 1
      },
      {
        "anchor": "home.tab-mobile",
        "side": "top",
        "title": "Make a phone app",
        "body": "**Mobile** builds an app for iPhone and Android. Try it on your own phone while you build.",
        "since": 4
      },
      {
        "anchor": "home.composer",
        "side": "bottom",
        "title": "Say what you need",
        "body": "Type it like you would tell a friend. Then send it. We take it from there.",
        "since": 1,
        "advance": {
          "kind": "input"
        },
        "hint": "Try it: type a few words"
      },
      {
        "anchor": "home.composer-mode",
        "side": "top",
        "title": "Build now, or plan first",
        "body": "**Build** starts right away. **Plan** talks it through with you first. You say go before it builds.",
        "since": 1,
        "advance": {
          "kind": "click"
        },
        "hint": "Try it: {click} to see both choices"
      },
      {
        "anchor": "home.composer-plus",
        "side": "top",
        "title": "Bring in an app",
        "body": "Already have an app on Github, Lovable, Bolt or Replit? Open **+** and pick **Import from GitHub**. Keep working on it here. It stays yours.",
        "since": 1
      },
      {
        "anchor": "home.recent",
        "side": "bottom",
        "title": "Pick up where you left off",
        "body": "The quickest and easiest way to resume your tasks. Every app you make shows up under **Recent**.",
        "since": 1,
        "optional": true
      },
      {
        "anchor": "home.sidebar-mode",
        "side": "right",
        "title": "Build or Chat",
        "body": "Switch between action and conversation. **Build** is for apps. **Chat** is for questions about your business.",
        "since": 1,
        "optional": true
      },
      {
        "anchor": "home.sidebar-apps",
        "side": "right",
        "title": "All your apps",
        "body": "**All Apps** holds every app you make. Open one to pick up where you left off.",
        "since": 1
      },
      {
        "anchor": "home.sidebar-templates",
        "side": "right",
        "title": "Start from a template",
        "body": "**Templates** are apps and pages that are already built. Replace software you pay for, or launch a landing page that wins customers. Pick one and make it yours.",
        "since": 3
      },
      {
        "anchor": "home.credit",
        "side": "right",
        "title": "Your credit",
        "body": "This shows the credit you have left. Each build uses a little. Run low and you can get more here.",
        "since": 4,
        "optional": true
      },
      {
        "anchor": "home.account",
        "side": "right",
        "title": "Invite friends, get credit",
        "body": "Open this menu and pick **Refer & earn**. Share your link. When a friend joins and builds, you both get credit.",
        "since": 4
      },
      {
        "anchor": "home.bulb",
        "side": "right",
        "title": "Find this again",
        "body": "Want this tour again? {Click} this bulb. It glows when a page has something new to show.",
        "since": 3
      }
    ]
  },
  "settings": {
    "id": "settings",
    "version": 2,
    "routes": [
      "/settings"
    ],
    "title": "Your settings",
    "auto": "never",
    "entry": "home.bulb",
    "steps": [
      {
        "anchor": "settings.tabs",
        "side": "bottom",
        "title": "Three parts",
        "body": "**Profile** is your name and picture. **GitHub** is where your code is kept. **Preferences** is how the app acts.",
        "since": 1,
        "advance": {
          "kind": "click"
        },
        "if": {
          "key": "billing",
          "value": "no"
        }
      },
      {
        "anchor": "settings.tabs",
        "side": "bottom",
        "title": "Four parts",
        "body": "**Profile** is your name and picture. **GitHub** is where your code is kept. **Preferences** is how the app acts. **Billing** is your plan and credit.",
        "since": 2,
        "advance": {
          "kind": "click"
        },
        "if": {
          "key": "billing",
          "value": "yes"
        }
      },
      {
        "anchor": "settings.github",
        "side": "bottom",
        "title": "Your code, kept safe",
        "body": "Connect **GitHub** to keep a copy of every app. You own it. Most people do this once.",
        "since": 1
      },
      {
        "anchor": "settings.preferences",
        "side": "bottom",
        "title": "How things act",
        "body": "Small switches that change how the app acts. Try one. You can always switch it back.",
        "since": 1
      },
      {
        "anchor": "settings.billing",
        "side": "bottom",
        "title": "Your plan and credit",
        "body": "**Billing** shows your plan and the credit you have left. Change your plan or see past payments from here.",
        "since": 2,
        "optional": true
      },
      {
        "anchor": "home.bulb",
        "side": "right",
        "title": "Find this again",
        "body": "Want this tour again? {Click} this bulb. It glows when a page has something new to show.",
        "since": 1
      }
    ]
  },
  "team": {
    "id": "team",
    "version": 1,
    "routes": [
      "/team"
    ],
    "title": "Your team",
    "auto": "never",
    "entry": "home.bulb",
    "steps": [
      {
        "anchor": "team.invite",
        "side": "left",
        "title": "Add people",
        "body": "{Click} **Invite**. Type their email. They get a link to join.",
        "since": 1,
        "optional": true
      },
      {
        "anchor": "team.members",
        "side": "bottom",
        "title": "Who is here",
        "body": "Everyone on your team shows here. Each person can be given some apps or all of them.",
        "since": 1,
        "highlight": "none",
        "optional": true
      },
      {
        "anchor": "home.bulb",
        "side": "right",
        "title": "Find this again",
        "body": "Want this tour again? {Click} this bulb. It glows when a page has something new to show.",
        "since": 1
      }
    ]
  },
  "templates": {
    "id": "templates",
    "version": 1,
    "routes": [
      "/templates"
    ],
    "title": "Start from a template",
    "auto": "new-user",
    "entry": "home.bulb",
    "steps": [
      {
        "anchor": "tpl.kinds",
        "side": "bottom",
        "title": "Two kinds of templates",
        "body": "**Software replacements** are ready-made apps for software you want to replace. **Landing pages** are sites that tell people about your business. {Click} a tab to switch.",
        "since": 1,
        "advance": {
          "kind": "click"
        },
        "hint": "Try it: {click} a tab"
      },
      {
        "anchor": "tpl.search",
        "side": "bottom",
        "title": "Search by the tool you pay for",
        "body": "Type the software you want to replace, like DocuSign or HubSpot. We will show the ones that fit.",
        "since": 1,
        "advance": {
          "kind": "input"
        },
        "hint": "Try it: type a tool name",
        "if": {
          "key": "kind",
          "value": "apps"
        }
      },
      {
        "anchor": "tpl.search",
        "side": "bottom",
        "title": "Search by what your business does",
        "body": "Type your line of work, like dental or plumbing. We will show the pages that fit.",
        "since": 1,
        "advance": {
          "kind": "input"
        },
        "hint": "Try it: type your line of work",
        "if": {
          "key": "kind",
          "value": "landing"
        }
      },
      {
        "anchor": "tpl.grid",
        "side": "top",
        "title": "Pick a template you like",
        "body": "{Click} any card to see it up close.",
        "since": 1,
        "highlight": "none",
        "advance": {
          "kind": "click"
        },
        "hint": "Try it: {click} a card",
        "if": {
          "key": "search",
          "value": "off"
        }
      },
      {
        "anchor": "tpl.result",
        "side": "right",
        "title": "Here is your match",
        "body": "This fits what you typed. {Click} it to see it up close. Not it? Clear the box to see them all.",
        "since": 1,
        "advance": {
          "kind": "click"
        },
        "hint": "Try it: {click} it",
        "if": {
          "key": "search",
          "value": "results"
        }
      },
      {
        "anchor": "tpl.search",
        "side": "bottom",
        "title": "No match yet",
        "body": "Nothing fits that name yet. Try another one, or clear the box to see them all.",
        "since": 1,
        "if": {
          "key": "search",
          "value": "none"
        }
      },
      {
        "anchor": "tpl.use",
        "side": "left",
        "title": "Make it yours",
        "body": "Like it? {Click} **Use this template**. You get your own copy. Then change it in the chat.",
        "since": 1,
        "optional": true
      },
      {
        "anchor": "home.bulb",
        "side": "right",
        "title": "Find this again",
        "body": "Want this tour again? {Click} this bulb. It glows when a page has something new to show.",
        "since": 1
      }
    ]
  },
  "workspace": {
    "id": "workspace",
    "version": 5,
    "routes": [
      "/tasks/:id"
    ],
    "title": "Building your app",
    "auto": "new-user",
    "entry": "ws.bulb",
    "steps": [
      {
        "anchor": "ws.preview",
        "side": "left",
        "title": "Your app shows up here",
        "body": "Your app is being built right now. Watch it take shape here. When it is ready, you can use it right here.",
        "since": 1,
        "highlight": "none",
        "if": {
          "key": "build",
          "value": "running"
        }
      },
      {
        "anchor": "ws.preview",
        "side": "left",
        "title": "Your app lives here",
        "body": "This is where your app lives. Once it is ready, you can use it right here, like the real thing.",
        "since": 1,
        "highlight": "none",
        "if": {
          "key": "build",
          "value": "idle"
        }
      },
      {
        "anchor": "ws.composer",
        "side": "top",
        "title": "Ask for changes here",
        "body": "Type what you want changed in this box. Use your own words. Each step shows up above as it happens.",
        "since": 1
      },
      {
        "anchor": "ws.picker",
        "side": "top",
        "title": "Point at the thing",
        "body": "Turn this on. Then {click} any part of your app. Now say what to change about it.",
        "since": 4,
        "optional": true
      },
      {
        "anchor": "ws.viewport",
        "side": "bottom",
        "title": "See it on a phone",
        "body": "Check how your app looks on a phone or a tablet.",
        "since": 4,
        "advance": {
          "kind": "click"
        },
        "hint": "Try it: {click} to switch",
        "optional": true
      },
      {
        "anchor": "ws.views",
        "side": "bottom",
        "title": "Preview, code changes, and more",
        "body": "Flip between your app and what your agent changed. The three dots hold more views.",
        "since": 1,
        "highlight": "none"
      },
      {
        "anchor": "ws.save",
        "side": "bottom",
        "title": "Save puts it online",
        "body": "**Save changes** keeps a safe copy and puts your changes online. You can go back to any save later.",
        "since": 1,
        "if": {
          "key": "app",
          "value": "imported"
        }
      },
      {
        "anchor": "ws.publish",
        "side": "bottom",
        "title": "Put it online",
        "body": "**Publish** gives your app a real web address. Send that link to anyone. On the free plan, you pick a plan first.",
        "since": 1,
        "optional": true,
        "if": {
          "key": "published",
          "value": "no"
        }
      },
      {
        "anchor": "ws.publish",
        "side": "bottom",
        "title": "Put your changes online",
        "body": "**Republish** puts your latest changes online. Your link stays the same.",
        "since": 1,
        "optional": true,
        "if": {
          "key": "published",
          "value": "yes"
        }
      },
      {
        "anchor": "ws.invite",
        "side": "bottom",
        "title": "Share with your team",
        "body": "Invite people to this app. They can open it and ask for changes too.",
        "since": 4,
        "optional": true
      },
      {
        "anchor": "ws.history",
        "side": "bottom",
        "title": "Go back in time",
        "body": "Every save is kept. Open this to go back to an older one.",
        "since": 4,
        "optional": true
      },
      {
        "anchor": "ws.task-rail",
        "side": "right",
        "title": "Every task on this app",
        "body": "Each thing you asked for is a task. Need a fresh start or a new feature? {Click} **Create New Task**. It gets its own chat.",
        "since": 1
      },
      {
        "anchor": "ws.back-to-apps",
        "side": "bottom",
        "title": "Head back home",
        "body": "This takes you to all your apps. Anything running here keeps going.",
        "since": 1
      },
      {
        "anchor": "ws.credit",
        "side": "right",
        "title": "Credit left",
        "body": "This shows the credit you have left while you build. Each build uses a little.",
        "since": 5
      },
      {
        "anchor": "ws.bulb",
        "side": "right",
        "title": "Find this again",
        "body": "Want this tour again? {Click} this bulb. Other pages have one too, above your avatar.",
        "since": 4
      }
    ]
  }
};

export const TOURS: { readonly [K in keyof typeof tours]: CoachTour } = tours;
export type GeneratedTourId = keyof typeof tours;

export const NUDGES: Readonly<Record<string, CoachNudge>> = {
  "first-build": {
    "id": "first-build",
    "when": "first-build",
    "routes": [
      "/tasks/:id"
    ],
    "anchor": "ws.preview",
    "side": "left",
    "title": "Your app is ready",
    "body": "This is the real thing. {Click} around in it. Want a change? Type it in the chat.",
    "once": true,
    "after": null,
    "unless": null,
    "resumes": null,
    "audience": "journey",
    "isNew": false,
    "highlight": "none"
  },
  "first-publish": {
    "id": "first-publish",
    "when": "first-publish",
    "routes": [
      "/tasks/:id"
    ],
    "anchor": "ws.publish",
    "side": "bottom",
    "title": "You are live",
    "body": "Your app has a web address now. Send the link to anyone. Change something? Publish again.",
    "once": true,
    "after": null,
    "unless": null,
    "resumes": null,
    "audience": "journey",
    "isNew": false
  },
  "home-resume": {
    "id": "home-resume",
    "when": "route-enter",
    "routes": [
      "/apps"
    ],
    "anchor": "home.bulb",
    "side": "right",
    "title": "Want to see the rest?",
    "body": "You left the home tour early to build. Want to see the rest? {Click} this bulb.",
    "once": true,
    "after": "first-app",
    "unless": null,
    "resumes": "home",
    "audience": "journey",
    "isNew": false
  },
  "journey-done": {
    "id": "journey-done",
    "when": "journey-done",
    "routes": [
      "/tasks/:id"
    ],
    "anchor": "ws.bulb",
    "side": "right",
    "title": "You did it",
    "body": "You made an app and saw it work. Want to look around this screen again? {Click} this bulb.",
    "once": true,
    "after": null,
    "unless": null,
    "resumes": null,
    "audience": "journey",
    "isNew": false
  },
  "show-me-around": {
    "id": "show-me-around",
    "when": "route-enter",
    "routes": [
      "/apps"
    ],
    "anchor": "home.bulb",
    "side": "right",
    "title": "Take a quick tour",
    "body": "Want a quick tour of this page? {Click} this bulb.",
    "once": true,
    "after": null,
    "unless": null,
    "resumes": null,
    "audience": "existing",
    "isNew": true
  },
  "template-picked": {
    "id": "template-picked",
    "when": "template-opened",
    "routes": [
      "/templates"
    ],
    "anchor": "tpl.use",
    "side": "left",
    "title": "Make it yours",
    "body": "This is the ready-made start you picked. {Click} **Use this template** to get your own copy. Then change it in the chat.",
    "once": true,
    "after": null,
    "unless": null,
    "resumes": null,
    "audience": "journey",
    "isNew": false
  }
};

export const TOUR_ROUTES: ReadonlyArray<{ readonly pattern: string; readonly tourId: GeneratedTourId }> = [
  {
    "pattern": "/apps/all",
    "tourId": "apps-all"
  },
  {
    "pattern": "/apps",
    "tourId": "home"
  },
  {
    "pattern": "/settings",
    "tourId": "settings"
  },
  {
    "pattern": "/team",
    "tourId": "team"
  },
  {
    "pattern": "/templates",
    "tourId": "templates"
  },
  {
    "pattern": "/apps/:id",
    "tourId": "app-details"
  },
  {
    "pattern": "/tasks/:id",
    "tourId": "workspace"
  }
];
